import apiClient from '../axiosConfig';
import { components } from '../types/openapi';

// Tipos del OpenAPI
type NotificationResponse = components['schemas']['NotificationResponse'];
type MenuNotificationResponse = components['schemas']['MenuNotificationResponse'];
type PaginationNotificationResponse = components['schemas']['Pagination_NotificationResponse_'];

/**
 * Servicio de notificaciones
 * Maneja todas las operaciones relacionadas con notificaciones
 * Basado en los endpoints del OpenAPI
 */
class NotificationService {
  /**
   * Obtener todas las notificaciones
   * GET /api/notifications/
   * Según OpenAPI: query params son search? y read? (NO page ni limit)
   */
  async getAllNotifications(params?: {
    search?: string;
    read?: string;
  }): Promise<NotificationResponse[]> {
    const response = await apiClient.get<NotificationResponse[]>('/notifications/', { params });
    return response.data;
  }

  /**
   * Obtener notificaciones con paginación
   * GET /api/notifications/pagination
   * Según OpenAPI: query params son page?, limit?, search?, read?
   */
  async getNotificationsPaginated(params?: {
    page?: number;
    limit?: number;
    search?: string;
    read?: string;
  }): Promise<PaginationNotificationResponse> {
    const response = await apiClient.get<PaginationNotificationResponse>('/notifications/pagination', { params });
    return response.data;
  }

  /**
   * Obtener notificaciones para el menú
   * GET /api/notifications/menu
   */
  async getMenuNotifications(): Promise<MenuNotificationResponse> {
    const response = await apiClient.get<MenuNotificationResponse>('/notifications/menu');
    return response.data;
  }

  /**
   * Obtener una notificación por ID
   * GET /api/notifications/{pk}
   */
  async getNotificationById(pk: number): Promise<NotificationResponse> {
    const response = await apiClient.get<NotificationResponse>(`/notifications/${pk}`);
    return response.data;
  }

  /**
   * Marcar notificación como leída
   * PUT /api/notifications/{pk}
   */
  async markAsRead(pk: number): Promise<NotificationResponse> {
    const response = await apiClient.put<NotificationResponse>(`/notifications/${pk}`);
    return response.data;
  }

  /**
   * Eliminar notificación
   * DELETE /api/notifications/{pk}
   */
  async deleteNotification(pk: number): Promise<void> {
    await apiClient.delete(`/notifications/${pk}`);
  }
}

export default new NotificationService();

